import { createAction } from 'redux-actions';

import {
  PRIVACY_SELECTED,
  TERMS_OF_SERVICE_SELECTED,
} from 'app/features/footer/actionTypes';

const privacySelected = createAction(PRIVACY_SELECTED);
const termsOfServiceSelected = createAction(TERMS_OF_SERVICE_SELECTED);

export { privacySelected, termsOfServiceSelected };
